import { render, staticRenderFns } from "./giftCount.vue?vue&type=template&id=8d2172bc&scoped=true&"
import script from "./giftCount.vue?vue&type=script&lang=js&"
export * from "./giftCount.vue?vue&type=script&lang=js&"
import style0 from "./giftCount.vue?vue&type=style&index=0&id=8d2172bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2172bc",
  null
  
)

export default component.exports